import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import bth from '../Images/bth.png'

// --- STYLED COMPONENTS ---

const ArticleContainer = styled.article`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 900px;
  margin: 0 auto;
  padding: 10px 20px;
  color: #333333;
  line-height: 1.6;
`;

const ContentCard = styled.div`
  background-color: #ffffff;
//   padding: 50px;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);

  @media (max-width: 640px) {
    padding: 25px 20px;
  }
`;

const MainTitle = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  color: #439E6D; /* Corporate dark navy */
  text-transform: uppercase;
//   margin: 0 0 15px 0;
  letter-spacing: -0.5px;
`;

const MetaInfo = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #439E6D; /* Your signature theme accent color */
//   margin-bottom: 30px;
  
  span {
    color: #64748b;
    font-weight: normal;
  }
`;

const CategoryLabel = styled.h2`
  font-size: 1.1rem;
  font-weight: 600;
  color: #64748b;
//   margin: 0 0 25px 0;
`;

const BlockParagraph = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
//   margin-bottom: 20px;
  text-align: justify;
`;

const RomanListContainer = styled.ol`
  list-style-type: none;
  padding-left: 0;
//   margin: 25px 0 35px 0;
`;

const RomanListItem = styled.li`
  font-size: 1.1rem;
  color: #4a5568;
//   margin-bottom: 12px;
  display: flex;
  gap: 8px;
  line-height: 1.5;

  span.prefix {
    color: #0c2340;
    font-weight: 600;
    min-width: 25px;
  }
`;

const SquareBulletList = styled.ul`
  list-style-type: none;
  padding-left: 0;
//   margin: 30px 0 0 0;
`;

const SquareBulletItem = styled.li`
  font-size: 1.1rem;
  color: #4a5568;
//   margin-bottom: 35px;
  position: relative;
  padding-left: 25px;
  line-height: 1.6;

  &::before {
    content: "▪"; /* Custom matching square bullet */
    color: #0c2340;
    font-size: 1.1rem;
    position: absolute;
    left: 2px;
    top: 1px;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const InlineImageSlot = styled.div`
  width: 100%;
  max-width: 620px;
  height: 360px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
//   margin: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  span {
    color: #94a3b8;
    font-size: 1.1rem;
  }
`;

// --- MAIN COMPONENT ---

const BathymetricSurveysArticle = () => {
  return (
    <ArticleContainer>
      <Fade triggerOnce direction="up" duration={800}>
        <ContentCard>
          
          {/* Header & Meta Context */}
          <MainTitle>BATHYMETRIC SURVEYS</MainTitle>
          <MetaInfo>
            By admin <span>/ May 14, 2024</span>
          </MetaInfo>

          <CategoryLabel>Special Survey</CategoryLabel>

          <BlockParagraph>
            The archive for all records of survey plans created in is included in this section.
          </BlockParagraph>

          <BlockParagraph>
            lands owned by the government are respected. Additionally, the archive serves as a 
            storage facility for official copies of survey plans created by independent surveyors in the 
            condition.
          </BlockParagraph>

          {/* Lowercase Roman Numeral Conditions List */}
          <RomanListContainer>
            <Fade triggerOnce cascade direction="up" duration={400} fraction={0.1} damping={0.05}>
              <RomanListItem>
                <span className="prefix">i.</span>
                <div>Examines survey designs i.e. (print copy and record copy comparison)</div>
              </RomanListItem>
              <RomanListItem>
                <span className="prefix">ii.</span>
                <div>Grants a certificate of the surveyors' deposit of record copies.</div>
              </RomanListItem>
              <RomanListItem>
                <span className="prefix">iii.</span>
                <div>Information on submitted record copies by surveyors is recorded in the register.</div>
              </RomanListItem>
              <RomanListItem>
                <span className="prefix">iv.</span>
                <div>Attaches the survey plan's control points to the surveyor's dossier for the hiring procedure at professional practices</div>
              </RomanListItem>
              <RomanListItem>
                <span className="prefix">v.</span>
                <div>Confirms the lodging of survey plans that are attached to petitions for statutory right of occupancy (C of O).</div>
              </RomanListItem>
              <RomanListItem>
                <span className="prefix">vi.</span>
                <div>Document the survey of government land and lodge it in the registry.</div>
              </RomanListItem>
            </Fade>
          </RomanListContainer>

          {/* Core Structured Features / Services */}
          <SquareBulletList>
            
            <SquareBulletItem>
              Statutory/Consultancy surveys for the issuance and renewal of pipeline routes ROW and concession/lease licenses.
              
              {/* Media Asset Anchor */}
              <InlineImageSlot>
                <img src={bth} onError={(e) => e.target.style.display='none'} />
               
              </InlineImageSlot>
            </SquareBulletItem>

            <SquareBulletItem>
              Land administration and management services
            </SquareBulletItem>

            <SquareBulletItem>
              Geographical information data management.
            </SquareBulletItem>

          </SquareBulletList>

        </ContentCard>
      </Fade>
    </ArticleContainer>
  );
};

export default BathymetricSurveysArticle;